import { useState } from "react";
import { RotateCcw, Check, X } from "lucide-react";

interface Props {
  term: string;
  definition: string;
  onReviewed: (term: string, confident: boolean) => void;
}

export default function VocabResurfaceCard({ term, definition, onReviewed }: Props) {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className="relative overflow-hidden rounded-xl border border-[hsl(340_80%_68%/0.25)] bg-gradient-to-br from-[hsl(340_55%_18%/0.5)] via-card/45 to-[hsl(355_50%_16%/0.3)] p-4">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[hsl(340_90%_72%/0.6)] to-transparent" />
      <div className="flex items-center gap-2 mb-2">
        <RotateCcw className="h-3.5 w-3.5 text-[hsl(340_90%_78%)]" />
        <span className="text-[10px] font-heading font-semibold uppercase tracking-[0.18em] text-[hsl(340_80%_82%)]">
          Vocabulary Review
        </span>
      </div>

      <p className="font-heading text-sm font-bold text-foreground mb-1">
        Do you remember what <span className="text-[hsl(340_90%_82%)]">{term}</span> means?
      </p>

      {!revealed ? (
        <button
          onClick={() => setRevealed(true)}
          className="mt-2 text-xs font-heading font-medium text-primary hover:text-primary/80 transition-colors"
        >
          Reveal definition →
        </button>
      ) : (
        <>
          <p className="font-body text-sm text-foreground/80 leading-relaxed mt-2">{definition}</p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={() => onReviewed(term, true)}
              className="flex items-center gap-1.5 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 text-xs font-heading font-semibold text-emerald-600 hover:bg-emerald-500/20 transition-colors"
            >
              <Check className="h-3 w-3" /> I knew it
            </button>
            <button
              onClick={() => onReviewed(term, false)}
              className="flex items-center gap-1.5 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-1.5 text-xs font-heading font-semibold text-red-500 hover:bg-red-500/20 transition-colors"
            >
              <X className="h-3 w-3" /> Review again
            </button>
          </div>
        </>
      )}
    </div>
  );
}
